import { TreeDndPlayground } from '@/components/tree-dnd';

export default function TreeDndSandboxPage() {
  return (
    <div className="p-8">
      <div className="mx-auto max-w-5xl">
        <TreeDndPlayground />
      </div>
    </div>
  );
}
